module.exports = __webpack_public_path__ + "img/xuanchuan.6beef668.jpg";